import React from 'react'
import { LiteralsService } from '../../services'
import StyledParagraph from './styles'

interface IProps {
  returnAfterEventEndMinutes?: number | null
  className?: string
}

export const EventEndNotice: React.FC<IProps> = ({ returnAfterEventEndMinutes, className }) => {
  if (!returnAfterEventEndMinutes) return null

  const notice = LiteralsService
    .get('returnAfterEventEnd', true)
    .replace('%MINUTESTOREPLACE%', returnAfterEventEndMinutes.toString())

  return (
    <StyledParagraph className={ className }>
      <span className='mark'>*</span>
      <span>{ notice }</span>
    </StyledParagraph>
  )
}
